module.exports = __webpack_public_path__ + "static/media/stamp-star-circle.f8bfb756.svg";